<template lang="">
  <div>결제완료~~</div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
